import {t} from "@lingui/core/macro";

export const ModeratedImage = ({testId}: {testId?: string}) => (
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={testId}
    >
        <title>{t`This image is not displayed because it was flagged by our moderation system`}</title>
        <rect
            x="1"
            y="1"
            width="126"
            height="126"
            rx="15"
            fill="#EDEDEE"
            stroke="#909296"
            strokeWidth="2"
        />
        <g clipPath="url(#clip0_21068_289607)">
            <path
                d="M77.5 82H50.5C50.10 82 49.72 81.84 49.44 81.56C49.16 81.28 49 80.90 49 80.5V47.5C49 47.10 49.16 46.72 49.44 46.44C49.72 46.16 50.10 46 50.5 46H68.5L79 56.5V80.5C79 80.90 78.84 81.28 78.56 81.56C78.28 81.84 77.90 82 77.5 82Z"
                stroke="#717378"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M68.5 46V56.5H79"
                stroke="#717378"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M59.5 64L68.5 73"
                stroke="#717378"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M68.5 64L59.5 73"
                stroke="#717378"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_21068_289607">
                <rect
                    width="48"
                    height="48"
                    fill="white"
                    transform="translate(40 40)"
                />
            </clipPath>
        </defs>
    </svg>
);
